import axios from "axios";
import React, {useState, useEffect, useCallback} from "react";
import {Alert, AlertDescription, AlertIcon, Center, Checkbox, Spinner, Stack, useToast} from "@chakra-ui/react";
import {coreUrls} from 'core_src/js/core_urls_config';

const newsletterAPIUrl = coreUrls.newsletter_api;

/**
 * Component to handle the newsletter selection process.
 * @param props - Props to pass to the component container.
 */
export const NewsletterSelection = (props) => {
        const [isLoaded, setIsLoaded] = useState(false);
        const [newsletters, setNewsletters] = useState([]);
        const [isErrorOnGet, setIsErrorOnGet] = useState(false);
        const toast = useToast();

        const {
            loadedNewsletterCallback,
            ...rest
        } = props;

        const postCallback = useCallback((option) => async (e) => {
            try {
                const isSelected = e.target.checked;
                const wording = isSelected ? "subscribed to" : "unsubscribed from";
                await axios.post(option.post_url, {selected: isSelected});
                toast({
                    position: 'bottom-right',
                    title: isSelected ? 'Subscribed' : 'Unsubscribed',
                    description: `You were successfully ${wording} ${option.label}.`,
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                });
            } catch (e) {
                console.error(e);
                toast({
                    position: 'bottom-right',
                    title: "Something went wrong.",
                    description: `We were unable to update your preferences for ${option.label}`,
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
            }
        }, [toast]);

        // Get the newsletters choices from the API.
        useEffect(() => {
            axios.get(newsletterAPIUrl).then(res => {
                setNewsletters(res.data);
                setIsLoaded(true);
                if (loadedNewsletterCallback) {
                    loadedNewsletterCallback(res.data);
                }
                return null;
            }).catch(error => {
                console.error(error);
                setIsErrorOnGet(true);
                if (loadedNewsletterCallback) {
                    loadedNewsletterCallback([]);
                }
            });
        }, [loadedNewsletterCallback]);

        if (isErrorOnGet) {
            return <Alert status="error" data-testid="error">
                <AlertIcon/>
                <AlertDescription>Something went wrong while loading the newsletters.</AlertDescription>
            </Alert>;
        }

        // Display a spinner until the data is received.
        if (!isLoaded) {
            return <Center data-testid="loading"><Spinner/></Center>;
        }

        return (
            <Stack spacing="4" {...rest}>
                {newsletters.map((option, index) => (
                    <Checkbox key={index} name={option.id} onChange={postCallback(option)}>
                        {option.label}
                    </Checkbox>)
                )}
            </Stack>
        );
    }
;
